export class EnumUtil {
  /**
   * Reverse mapping pour string enum. Pour les enum numériques utiliser la fonctionnalité built-in du langage.
   */
  static getStringEnumKeyByStringValueOrDefault<T extends { [K in string]: string }>(
    enumObj: T,
    value: string,
    defaultKey: T[keyof T]
  ): T[keyof T] {
    const key = EnumUtil.getStringEnumKeyByStringValueOrNull(enumObj, value);
    if (key == null) {
      return defaultKey;
    }
    return key;
  }

  /**
   * Reverse mapping pour string enum. Pour les enum numériques utiliser la fonctionnalité built-in du langage.
   */
  static getStringEnumKeyByStringValueOrThrow<T extends { [K in string]: string }>(
    enumObj: T,
    value: string
  ): T[keyof T] {
    const key = EnumUtil.getStringEnumKeyByStringValueOrNull(enumObj, value);
    if (key == null) {
      throw new Error('SPACAAD.999999');
    }

    return key;
  }

  static getStringEnumStringValues<T extends { [K in string]: string }>(e: T): Array<string> {
    return Object.values(e);
  }

  static getEnumKeys<T extends { [K in string]: string }>(e: T): Array<keyof T> {
    return Object.keys(e);
  }

  /**
   * Reverse mapping pour string enum. Pour les enum numériques utiliser la fonctionnalité built-in du langage.
   */
  private static getStringEnumKeyByStringValueOrNull<T extends { [K in string]: string }>(
    enumObj: T,
    value: string
  ): T[keyof T] | null {
    const key = this.getEnumKeys(enumObj).find((key) => enumObj[key] === value);
    if (key == null) {
      return null;
    }

    return enumObj[key];
  }
}
